<template>
  <div class="p-14">
    <router-link class="flex justify-center text-4xl text-yellow-700" to="/"
      >Pokemon Picker</router-link
    >
  </div>
  <router-view />
</template>

<style></style>
